import Avatar1x from "../components/core/Avatar/assets/avatar-light_1x.webp";
import Avatar2x from "../components/core/Avatar/assets/avatar-light_2x.webp";
import Avatar3x from "../components/core/Avatar/assets/avatar-light_3x.webp";

export type IAvatarSize = "s" | "m" | "l" | "ml" | "xl" | "xxl" | "xxxl";
export const DefaultProfileSrcSet = `${Avatar1x} 1x, ${Avatar2x} 2x, ${Avatar3x} 3x`;

export const AvatarWidthMapping = {
  s: 40,
  m: 60,
  l: 80,
  ml: 95,
  xl: 120,
  xxl: 160,
  xxxl: 255,
};

export const AvatarHeightMapping = {
  s: 55,
  m: 80,
  l: 108,
  ml: 95,
  xl: 162,
  xxl: 220.274,
  xxxl: 340,
};

export enum LevelValue {
  UnRanked = 0,
  Beginner = 3,
  Intermediate = 20,
  Advanced = 50,
  Expert = 200,
  Master = 500,
  Champion = 1000,
  GrandChampion = 2000,
}

export const getSizeBadge = (size: IAvatarSize) => {
  switch (size) {
    case "s":
      return "s";
    case "m":
      return "m";
    default:
      return "l";
  }
};

export enum RankGem {
  UnRanked = "Unranked",
  Beginner = "Beginner",
  Intermediate = "Intermediate",
  Advanced = "Advanced",
  Expert = "Expert",
  Master = "Master",
  Champion = "Champion",
  GrandChampion = "Grand Champion",
}

export enum RankColor {
  UnRanked = "linear-gradient(270deg, #FFF 0.03%, #DADADA 97.98%)",
  Beginner = "linear-gradient(100deg, #F0DBC0 11.57%, #C59674 89.29%)",
  Intermediate = "linear-gradient(100deg, #D6D7DF 11.57%, #C1C1C1 89.29%)",
  Advanced = "linear-gradient(100deg, #AAE2EA 11.57%, #09BED4 89.29%)",
  Expert = "linear-gradient(100deg, #DEE588 11.57%, #9BA249 89.29%)",
  Master = "linear-gradient(100deg, #F1DCC1 11.57%, #E3B97E 89.29%)",
  Champion = "linear-gradient(100deg, #EB8FE8 11.57%, #B642B2 89.29%)",
  GrandChampion = "linear-gradient(100deg, #656565 11.57%, #2F3030 89.29%)",
}
